var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconDocs = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  width: "19px",
  height: "20px",
  viewBox: "0 0 19 20",
  enableBackground: "new 0 0 19 20",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
  id: "image0",
  width: 19,
  height: 20,
  x: 0,
  y: 0,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAUCAAAAABKPlmoAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZ cwAADsMAAA7DAcdvqGQAAAAHdElNRQflBRkEGQIdq9ccAAABEUlEQVQY02P8z4ABWBgYGM49YWL4 pqOFLLa6j4vhh2bYnRkXhaP8GBgYGJgYGE4J8HIJzzkYc87wX2M+VB0jA8PPYIZGzWmcDIsmbPFh YGBiYGBkYPjlceB9JScDQ5zcJoheBgaGfyIvmNUYGBgYtL/CxZifKv09wcDAwHBOAC7GvtFMtvUu w9/6zy4MDAyM/xnKL7H/+7HhVcon+Xc/udlnSkLVMbGkKezJknGaYfkh5SVUHcP/30xpfgwMn3kr Dgtthoox/P/3/SfHd+Zqtxp7V5gYAwPDfwaGPywb4fYyMDAwMDAyMjKxfUcVgwMmBoa/SNz/0DBQ O84NE/otwAlxM8PWB8wQoX9cQXxQMXQAAPj/VCnXTqLYAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIx LTA1LTI1VDA0OjI1OjAyKzAzOjAwcI1kjQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0wNS0yNVQw NDoyNTowMiswMzowMAHQ3DEAAAAASUVORK5CYII="
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDocs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconDocs.e2e7b3fc.svg";
export { ForwardRef as ReactComponent };